<template>
  <div>
    <multiline-input
      v-if="xSubjectInput"
      ref="subject"
      class="subject"
      :value="subject"
      :placeholder="__('Title')"
      dir="auto"
      @input="onSubjectChange"
      @enter="onSubjectEnterKeydown"
      @focus="onSubjectFocus"
    />
    <rich-text-editor
      ref="editor"
      class="body"
      :toolbar-id="toolbarId"
      :value="body"
      :aria-label="__('Write post content')"
      :placeholder="__('Write something ...')"
      dir="auto"
      @input="onBodyChange"
      @focus="onBodyFocus"
      @blur="onBodyBlur"
      @selectionchange="onBodySelectionChange"
      @fileaccept="onBodyFileAccept"
    />
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapState, mapGetters } from 'vuex'
import MultilineInput from 'vuecomponents/multiline_input'
import RichTextEditor from 'vuecomponents/rich_text_editor'
import TrixToolbarMixin from 'vuemixins/trix_toolbar_mixin'
import { $ } from 'bits/jquery'
import { PostConfiguration } from 'vuexstore/helpers/post'

export default {
  components: { MultilineInput, RichTextEditor },
  mixins: [TrixToolbarMixin],
  props: {
    post: { type: Object, required: true },
  },
  computed: {
    ...mapState(['isMobile', 'isApp']),
    ...mapState('map', ['map']),
    ...mapGetters('post', ['postConfiguration']),
    subject() {
      return this.post.subject
    },
    body() {
      return this.post.body
    },
    isToolbarFloating() {
      return !this.isMobile
    },
    fixedToolbar() {
      return this.isMobile && !this.isApp
    },
    xSubjectInput() {
      if (this.subject) return true

      switch (this.postConfiguration) {
        case PostConfiguration.BodyOrAttachment:
        case PostConfiguration.BodyAndOrAttachment:
          return false
        case PostConfiguration.All:
        default:
          return true
      }
    },
  },
  watch: {
    toolbarInputFocused(newValue) {
      if (newValue && this.fixedToolbar) {
        this.showTrixToolbar()
      }
    },
  },
  async mounted() {
    this.$nextTick(() => this.focus())
    if (this.map) {
      // words_edit on Map need refocusing after 100ms in order
      // to regain focus on the words_edit after the map is panned or zoomed
      // once the popup is opened
      const { MapEventsManager } = await import('bits/map')
      this.endBoundsChangedListener = MapEventsManager.addListener(this.map, 'idle', () => {
        setTimeout(() => {
          this.focus()
        }, 100)
      })
    }
  },
  updated() {
    const minHeight = $('.body', this.$el).css('lineHeight')
    $(this.$refs.editor.$refs.editor).css('min-height', minHeight)
  },
  beforeDestroy() {
    this.hideTrixToolbar()
    this.endBoundsChangedListener && this.endBoundsChangedListener.remove()
  },
  methods: {
    focus() {
      if (!this.post.id && this.xSubjectInput) {
        // post is new
        this.$refs.subject.focus()
      } else {
        this.$refs.editor.focus()
      }
    },
    onSubjectChange(newValue) {
      this.$emit('text-change', {
        subject: newValue,
      })
    },

    onSubjectFocus(e) {
      if (!this.isToolbarFloating) {
        this.hideTrixToolbar()
      }
    },

    onSubjectEnterKeydown() {
      this.$refs.editor.focus()
    },

    onBodyChange(html) {
      const sanitizedHtml = html.replace(/<span style="background-color: highlight;">(.*?)<\/span>/g, '$1')
      this.$emit('text-change', {
        body: sanitizedHtml,
      })
    },
    onBodyFocus() {
      if (this.fixedToolbar) {
        this.showTrixToolbar()
      }
    },
    onBodyBlur() {
      if (this.fixedToolbar && !this.toolbarInputFocused) {
        this.hideTrixToolbar()
      }
    },
    onBodySelectionChange() {
      this.repositionTrixToolbar()
    },
    onBodyFileAccept(e) {
      e.preventDefault()
    },
  },
}
</script>
